<template>
  <div>
    <div class="inner-header ">
      <nav class="navbar fixed-top bg-white animate__animated animate__slideInRight">
        <a  @click="$router.go(-1)" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
         </a>
         <a href="javascript:void(0);" class="link-title">Edit Meeting</a>
      </nav>
    </div>
    <div class="inner-page bg-white animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card form-card">
                        <div class="card-body p-0">
                            <div class="row">
                               <div class="col-12">
                                    <span class="lead-heading mt-4 mb-4">Enter Cp Meeting Details</span>
                                </div>
                                <div class="col-12">
                                    <b-form @submit.prevent="EditMyCpMeetingDetails">
                                          <b-form-group label="">
                                            <label>Comment</label>
                                            <b-form-textarea v-model="EditMyCpMeeting.comment" placeholder="Comment" rows="3" max-rows="6"></b-form-textarea>
                                          </b-form-group>
                                          <b-form-group>
                                              <b-form-checkbox v-model="EditMyCpMeeting.is_flagged" value="true"
                                                  unchecked-value="false"><span class="name mt-1">Is Flagged?</span>
                                              </b-form-checkbox>
                                          </b-form-group>
                                          <b-form-group v-if="EditMyCpMeeting.is_flagged">
                                          <label>Flagged Reason<span class="text-danger">*</span></label>
                                          <b-form-textarea 
                                            v-model="EditMyCpMeeting.flagged_reason" 
                                            placeholder="Flagged Reason" 
                                            rows="3" 
                                            max-rows="6"
                                            :required="EditMyCpMeeting.is_flagged"
                                          ></b-form-textarea>
                                        </b-form-group>
                                      <b-form-group class="mt-5">
                                        <b-button variant="primary" type="submit" block>Save</b-button>
                                      </b-form-group>
                                    </b-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import {decodeEditMeetingParams} from '@/assets/scripts/utility.js';
import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'

export default {
  name: 'EditMyCpMeeting',
  components: {
    datetime: Datetime,
    Multiselect
  },
  data() {
    return {
			EditMyCpMeeting: {},
    }
  },
  mounted(){
    this.updateFieldRequired();
    this.GetMeetingDetailsONEdit(this.$route.params.id);
  },
  computed: {
    
  },
  methods: {
  GetMeetingDetailsONEdit(MeetingId) {
      this.$axios.get(`/cp_meeting_requests/${MeetingId}`).then((res) => {
        this.EditMyCpMeeting =  res.data.cp_meeting
        this.updateFieldRequired();
      });
  },
  
  EditMyCpMeetingDetails() {
      let apiParams = decodeEditMeetingParams(this.EditMyCpMeeting);
      this.$axios
        .put(`/users/meetings/${this.$route.params.id}`, { users_meeting  : apiParams })
        .then((res) => {
          swal({
            title: "Meeting Updated!",
            icon: "success",
          }).then(this.$router.replace({ name: "MyCpMeetingDetails", params: {id: this.$route.params.id } }));
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });

    },
   
    updateFieldRequired() {
      this.$nextTick(() => {
        this.$refs.multiselect.$el.querySelector('input').required = !this.EditMyCpMeeting.user_id || !this.EditMyCpMeeting.user_id.value;
        });
      }
  },

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.bgcolor {
  background: #f58321;
  color: white
}
table{
      font-size: 12px;
    font-weight: 400;
}
.btn-white-small{
  padding: 4px 8px;
  background: #fff;
  border: 1px solid #dfdfdf;
  margin-right: 5px;
}
.campaign-comment{
  white-space: pre-line;
}
</style>